<script lang="ts" setup>
import { GImage } from '@flash-global66/g-image';
import {
  BETWEEN_ACCOUNTS_SUCCESS_DETAILS_TITLE,
  BETWEEN_ACCOUNTS_SUCCESS_TITLE,
} from '../../constants/betweenAccounts.constant';
import type { BetweenAccountsSuccessCardProps } from '../../types/betweenAccountsSuccess.type';

defineOptions({ name: 'BetweenAccountsSuccessCard' });

defineProps<BetweenAccountsSuccessCardProps>();
</script>

<template>
  <section
    data-test="between-accounts-success-card"
    class="flex w-full flex-col gap-2xl rounded-md border border-grey-50 bg-white px-xl py-2xl"
  >
    <div class="flex w-full flex-col items-center gap-md">
      <GImage name="rocket" size="xl" :lazy-load="false" />
      <h3 class="text-center text-9 leading-9 font-bold text-primary-txt">{{ BETWEEN_ACCOUNTS_SUCCESS_TITLE }}</h3>
    </div>

    <div class="flex w-full flex-col gap-md">
      <p class="text-5 font-bold text-secondary-txt">{{ BETWEEN_ACCOUNTS_SUCCESS_DETAILS_TITLE }}</p>
      <div class="h-px w-full bg-blue-50" />
      <dl class="flex flex-col gap-md">
        <div
          v-for="detail in details"
          :key="detail.id"
          class="flex items-center justify-between gap-md text-4 text-terciary-txt"
          :data-test="`detail:${detail.id}`"
        >
          <dt class="font-medium">{{ detail.label }}</dt>
          <dd class="text-right font-semibold">{{ detail.value }}</dd>
        </div>
      </dl>
    </div>
  </section>
</template>
